import type { QueryFunctionContext } from "@tanstack/react-query"
import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import type { IAttendanceSessionDto as IDto } from "@/3514/types"
import { extractNumberFromQueryKeyPart } from "@/3514/utils"

import { EAttendanceMarksQueryKey as EKey, EAttendanceMarksQueryUrl as EUrl } from "./attendance.modal.api.config"

export default {
    async attendanceMarks({ queryKey }: QueryFunctionContext<ReturnType<typeof EKey>>): Promise<IDto> {
        const { data }: AxiosResponse<IDto> = await axiosClient.get<IDto>(
            EUrl({ sessionId: extractNumberFromQueryKeyPart(queryKey[1]) })
        )

        return data
    }
}
